import React, { CSSProperties, ReactElement } from 'react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';

import { Tooltip } from '../../../../components';

const overlayStyle: CSSProperties = { maxWidth: 400 };
const getAttributePath = (nameParts: string[]): ReactElement => (
	<>
		{nameParts.map((name, index) => (
			<span key={`partial-${name}`}>
				<span className="partial">{name}</span>
				{index < nameParts.length - 1 && (
					<BringgIcon iconName={BringgFontIcons.ChevronRight} className="chevron-icon" />
				)}
			</span>
		))}
	</>
);

interface AttributePathProps {
	path: string;
	separator?: string;
	searchPhrase?: string;
	maxPathItems?: number;
}

const AttributePath = ({ path, separator, maxPathItems = 0 }: AttributePathProps) => {
	const split = path.split(separator || '.');
	const { length } = split;

	if (length === 1) {
		return <>{path}</>;
	}

	const displayShortPath = maxPathItems && maxPathItems > 0 && length > maxPathItems;
	const fullPath = getAttributePath(split);

	return displayShortPath ? (
		<Tooltip title={fullPath} overlayStyle={overlayStyle}>
			<span className="short-attribute-path">
				{getAttributePath(['...', ...split.slice(length - maxPathItems)])}
			</span>
		</Tooltip>
	) : (
		fullPath
	);
};

export default AttributePath;
